<template>
    <CoalDialogVue></CoalDialogVue>
    <div class="setprisouter" v-if="(nft != undefined)" v-show="nft != undefined">
        <div class="setpris" style="display:flex;flex-direction: column;">
            <CoalRend style="margin-bottom: 10%;border-style: dotted;border-radius: 10%;border-color: white;padding: 10%;" :nft="nft"></CoalRend>
            <div style="font-size: 14pt;">Set Price for NFT # {{ nft ? nft.id : '' }}</div>

            <hr style="width: 100%;margin-bottom: 6%;">
            <div>Price: <input v-model="new_price" autofocus id="pris_id" type="text"  autocomplete="off"  style="text-align: center;color: black;"
                    v-bind:placeholder="cprice" /> $KDA
            </div>
            <div style="margin-top: 5%;">On-Sale?: <input type="checkbox" v-bind:true-value="1" v-bind:false-value="0"
                    v-model="new_onsale" /></div>
            <!-- <div>Sale-End: </div> -->
            <button style=" width: 100%;margin-top: 5%;" @click="set_state()">
                <div v-show="!in_loading">Set</div>
                <div style="margin:auto;" v-show="in_loading">
                    <LoadingCompVue lwidth="32" lheight="32" style=""></LoadingCompVue>
                </div>

            </button>

            <button style="align-self: center;width: 40%;margin-top: 10%;"
                @click="$parent.cur_set_price_nft = undefined">Close</button>
        </div>
    </div>
</template>

<script>

import { calc_price } from '@/utility';
import ENUMS from '../Enums';
import LoadingCompVue from '../LoadingComp.vue';
import CoalDialogVue from './CoalDialog.vue';
import CoalRend from './CoalRend.vue';

export default {
    name: 'CoalSetPriceComp'
    , data() {
        return {
            ENUMS: ENUMS
            // , nft: undefined
            , new_price: undefined
            , new_onsale: 1
            , new_saleend: -1.0
            , in_loading: false
            , dialog_message: undefined
        }
    }
    , props: ["nft"]
    , mounted() {
        this.new_price = undefined
    }
    , computed: {
        cprice() {
            return this.nft ? this.nft.get_price() : ""
        }

    }, components: { LoadingCompVue, CoalDialogVue, CoalRend }
    , methods: {

        set_state() {
            var qthis = this
            if(qthis.new_price == undefined){
                qthis.dialog_message = "new price can not be empty"
                return
            }
            this.in_loading = true
            qthis.nft.set_remote_price(qthis.new_price, qthis.new_onsale, qthis.new_saleend).catch((x) => {
                qthis.dialog_message = x
                throw { reason: "something_wrong", data: x }
            }).then((x) => {
                console.log("*(*(*))",x)
                qthis.$parent.reload()
                qthis.$parent.cur_set_price_nft = undefined
            }).finally(() => {
                qthis.in_loading = false
            })
        }, calc_price: calc_price
    }
}

</script>

<style scoped>

</style>